import React, {useEffect} from 'react';
import NavTopBar from "./nav-top-bar";
import MainNav from "./main-nav";
import SzMainNav from "./sz-main-nav";

const Navigation = ({partner, tripTypes, destinations}) => {
    // Call fetchData on component mount
    useEffect(() => {

    }, []);

    // close Mobile nav
    const offCanvas = document.getElementById('offcanvasNavbar2');
    if (offCanvas) {
        const close = document.getElementById('closeOffCanvas');
        const aElements = document.querySelectorAll(".offcanvas-body a");
        aElements.forEach(function (elem) {
            elem.addEventListener("click", function () {
                close.click();
            });
        });
        /*offCanvas.addEventListener("click", e => {
            close.click();
        })*/
    }

    return (
        <div>
            <NavTopBar partner={partner}></NavTopBar>
            {Number(partner.agency_no) === Number(process.env.REACT_APP_SZ_AGENCY_NO) ? (
                <SzMainNav partner={partner} destinations={destinations} tripTypes={tripTypes}></SzMainNav>
            ) : (
                <MainNav partner={partner} destinations={destinations} tripTypes={tripTypes}></MainNav>)}
        </div>
    )
}

export default Navigation;